import React from 'react'
import { AlertTriangle, RefreshCw, Home } from 'lucide-react'
import { Link } from 'react-router-dom'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught an error:', error, errorInfo)
    this.setState({
      error,
      errorInfo
    })

    // Log to error reporting service (Sentry, etc.)
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: error.toString(),
        fatal: true
      })
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-dark flex items-center justify-center px-4">
          <div className="max-w-2xl w-full">
            <div className="bg-gradient-to-br from-bronze-900 to-bronze-950 rounded-2xl p-8 sm:p-12 border-2 border-red-500/30">
              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-red-500/20 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-10 h-10 text-red-400" />
              </div>

              {/* Title */}
              <h1 className="text-3xl sm:text-4xl font-display font-bold text-center text-cream mb-4">
                Oops! Dicka shkoi gabim
              </h1>

              {/* Message */}
              <p className="text-beige-300 text-center text-lg mb-8">
                Na vjen keq, por ndodhi një gabim i papritur. Ekipi ynë është njoftuar dhe do ta rregullojmë sapo të jetë e mundur.
              </p>

              {/* Error Details (Development only) */}
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <details className="mb-8 p-4 bg-bronze-800 rounded-xl">
                  <summary className="cursor-pointer text-beige-300 font-semibold mb-2">
                    Detaje Teknike (vetëm për zhvillim)
                  </summary>
                  <pre className="text-xs text-red-400 overflow-auto">
                    {this.state.error.toString()}
                    {'\n\n'}
                    {this.state.errorInfo?.componentStack}
                  </pre>
                </details>
              )}

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={this.handleReset}
                  className="flex-1 flex items-center justify-center gap-2 px-8 py-4 bg-gradient-gold text-white font-bold rounded-xl shadow-lg hover:shadow-gold-400/50 transition-all"
                >
                  <RefreshCw className="w-5 h-5" />
                  Provo Përsëri
                </button>

                <Link
                  to="/"
                  className="flex-1 flex items-center justify-center gap-2 px-8 py-4 bg-bronze-800 border-2 border-gold-400/30 text-cream font-semibold rounded-xl hover:border-gold-400 transition-all"
                >
                  <Home className="w-5 h-5" />
                  Kthehu në Home
                </Link>
              </div>

              {/* Support Info */}
              <div className="mt-8 text-center">
                <p className="text-beige-400 text-sm mb-2">
                  Nëse problemi vazhdon, na kontaktoni:
                </p>
                <a
                  href="mailto:support@contenta.al"
                  className="text-gold-400 hover:text-gold-300 underline"
                >
                  support@contenta.al
                </a>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
